import styled, { css } from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { label12 } from '../../styles/typography';

export enum LabelVariant {
  Success = 'success',
  Warning = 'warning',
}

const Host = styled.div<{ variant: LabelVariant }>`
  ${label12};
  line-height: 1;
  display: inline-flex;
  padding: 4px ${gutter(1)} 4px;

  /* Background */
  ${(props) => {
    switch (props.variant) {
      case LabelVariant.Success:
        return css`
          background-color: ${color('green20')};
        `;
      case LabelVariant.Warning:
        return css`
          background-color: ${color('orange20')};
        `;
    }
  }}
`;

interface LabelProps {
  children: React.ReactNode;
  variant?: LabelVariant;
}

export const Label = ({
  children,
  variant = LabelVariant.Success,
}: LabelProps) => {
  return <Host variant={variant}>{children}</Host>;
};
